<div class="wrapper">
  @if (icon) {
    <div class="icon-container">
      <i class="icon" [ngClass]="icon"></i>
    </div>
  }
  <div class="message-container">
    <span class="message" [ngClass]="{ 'no-margin-top': !icon }">
      {{ message }}
      @if (!message) {
        <ng-content></ng-content>
      }
    </span>
  </div>
  @if (showRefreshButton && !link) {
    <button
      [class]="buttonStyleClass || 'size-l refresh-button'"
      alg-button
      (click)="onRefresh($event)"
    >{{ buttonCaption }}</button>
  }
  @if (link) {
    <a
      class="size-l refresh-button"
      alg-button
      [routerLink]="link"
    >{{ buttonCaption }}</a>
  }
</div>
